// @ts-nocheck
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, IconButton, Typography, Box, useTheme } from '@mui/material';
import { ReactComponent as OverrideRationalIcon } from '../../assets/images/OverrideRationalIcon.svg';

/**
 * @component OverrideRationaleTooltip
 * @description Displays an info icon with a tooltip containing override justification text.
 * Appears only when justification is provided.
 */
const OverrideRationaleTooltip = ({ justification }) => {
  const theme = useTheme();

  const tooltipContent = useMemo(() => {
    return (
      <Box sx={{ maxWidth: 350, whiteSpace: 'normal' }}>
        <Typography variant="body1" component="span" fontWeight="medium">
          Override Rationale:
        </Typography>
        <Typography variant="body2" component="span">
          &nbsp;&nbsp;{justification}
        </Typography>
      </Box>
    );
  }, [justification]);

  if (!justification || justification.trim().length === 0) {
    return null;
  }

  return (
    <Tooltip
      title={tooltipContent}
      placement="bottom"
      arrow
      componentsProps={{
        tooltip: {},
        arrow: {
          sx: {
            color: theme?.palette?.primary?.main,
          },
        },
      }}
    >
      <IconButton
        sx={{
          p: 0,
          ml: 0.5,
          mt: -0.5,
          color: theme?.palette?.primary?.main,
        }}
      >
        <OverrideRationalIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

OverrideRationaleTooltip.propTypes = {
  justification: PropTypes.string,
};

export default OverrideRationaleTooltip;
